import React from 'react';
import { Link } from 'react-router';
import { Card } from '../../../components/Card';
import { Section } from '../../../components/Section';
import { news } from '../data/news';

export const LatestNews: React.FC = () => {
  const latestNews = news.slice(0, 3);

  const formatDate = (dateString: string) => {
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' });
  };

  return (
    <Section>
      <h2
        style={{
          fontSize: '34px',
          fontWeight: 700,
          color: 'var(--text)',
          marginBottom: '32px',
        }}
        className="sectionTitle"
      >
        Latest News
      </h2>

      <div
        style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(3, 1fr)',
          gap: '24px',
        }}
        className="newsGrid"
      >
        {latestNews.map((item) => (
          <Link
            key={item.id}
            to={`/news/${item.slug}`}
            style={{ textDecoration: 'none' }}
          >
            <Card hoverable style={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                  marginBottom: '12px',
                }}
              >
                <span
                  style={{
                    fontSize: '12px',
                    fontWeight: 600,
                    color: 'var(--g1)',
                    textTransform: 'uppercase',
                    letterSpacing: '0.5px',
                  }}
                >
                  {item.tag}
                </span>
                <span
                  style={{
                    fontSize: '12px',
                    color: 'var(--muted)',
                  }}
                >
                  {formatDate(item.date)}
                </span>
              </div>
              <h3
                style={{
                  fontSize: '18px',
                  fontWeight: 600,
                  color: 'var(--text)',
                  marginBottom: '12px',
                  lineHeight: 1.35,
                }}
              >
                {item.title}
              </h3>
              <p
                style={{
                  color: 'var(--muted)',
                  fontSize: '14px',
                  lineHeight: 1.6,
                  flexGrow: 1,
                }}
              >
                {item.excerpt}
              </p>
            </Card>
          </Link>
        ))}
      </div>
    </Section>
  );
};

